"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M10.853 4H8a2 2 0 0 0-2 2v36a2 2 0 0 0 2 2h2.853a4 4 0 0 0 2.12-.608l30.09-17.667a2 2 0 0 0 0-3.449L12.973 4.608A4 4 0 0 0 10.853 4z" })
);

